(function () {
  var api = window.artov5.api;
  var views = window.artov5.views;
  var ARTOv5ViewSpot = window.artov5.ARTOv5ViewSpot;

  var pathToTextures = `${window.Speculator.baseUrl}/textures/`;
  var pathToOcclusionModel = `${window.Speculator.baseUrl}/occlusion_head.artov5`;
  var pathToMatCollection = `${window.Speculator.baseUrl}/mat_collection.artov5`;

  var view0;

  ARTOv5ViewSpot.prototype.loadModel = function (pathToModel, pathToTextures, nameModel, materialConfig) {
    var models = this.models;

    for (var i = 0; i < models.length; i++) {
      var model = models[i];

      if (!model.isOcclusionModel && !model.isMaterialCollection) {
        model.pathToModel = pathToModel;
        model.pathToTextures = pathToTextures;
        model.nameModel = nameModel;
        model.materialConfig = materialConfig;
        model.changeCounter += 1;
      }
    }
  };

  ARTOv5ViewSpot.prototype.updateMaterialConfig = function () {
    if (this.api.updateMaterialConfig) {
      this.api.updateMaterialConfig();
    }
  };

  api.setupViews = function () {
    view0 = api.setup3DViewSpot('full-view', pathToOcclusionModel, pathToMatCollection, pathToTextures);

    views.push(view0);
  };

  api.set3DModelConfig = function (config) {
    if (!config) return;

    view0.loadModel(config.pathToModel, config.pathToTextures, 'reference', config.materialConfig);
    view0.updateMaterialConfig();
  };

  ARTOv5ViewSpot.prototype.set3DModel = function (object3D, pathToTextures, nameModel) {
    var models = this.models;

    for (var i = 0; i < models.length; i++) {
      var model = models[i];

      if (!model.isOcclusionModel && !model.isMaterialCollection) {
        model.object3D = object3D;
        model.pathToModel = object3D.name;
        model.pathToTextures = pathToTextures;
        model.nameModel = nameModel;
      }
    }
  };

  api.set3DModel = function (object3D) {
    //    console.log('set3DModel', view0,  view0.set3DModel)

    if (view0) {
      view0.set3DModel(object3D, pathToTextures, null);
      view0.updateMaterialConfig();

      // view0.viewSpot = 'full-view'
      // view1.viewSpot = 'hidden'
    }
  };

  api.setupViews();
})();
